export * from './basic-modal/basic-modal.component';
export * from './connect/connect.component';
export * from './leaving/leaving.component';
export * from './media/media.component';
export * from './old-ie/old-ie.component';
export * from './thankyou/thankyou.component';
export * from './welcome/welcome.component';
